import { render, staticRenderFns } from "./distributionorder.vue?vue&type=template&id=5cfa8968&"
import script from "./distributionorder.vue?vue&type=script&lang=js&"
export * from "./distributionorder.vue?vue&type=script&lang=js&"
import style0 from "./distributionorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports